import styled from 'styled-components';
import { Button } from 'common/ui/Button';

export const ActionButton = styled(Button)`
  right: 1em;
  left: 2px;
  top: 2px;
  width: 50px;
`;
